/* ============
 * order received
 * ============
 *
 */
import { mapGetters } from 'vuex';
import userWidgetsService from './../../../services/widgets';

export default {

  data() {
    return {
      number: 0,
      loaded: false,
      currencyCode: 'no-NO',
      currencySymbol: 'Kr.',
    };
  },

  computed: {
    ...mapGetters({
      revenueWidgets: 'revenueWidgets',
    }),
  },

  watch: {
    revenueWidgets(revenueWidgets) {
      this.number = revenueWidgets.items;
      this.loaded = true;
    },
  },

  methods: {
    initializeWidgets() {
      Promise.all([
        userWidgetsService.fetchRevenueWidgets(),
      ]).then(() => {
        this.number = this.revenueWidgets.items;
        this.loaded = true;
      });
    },

    initializeCurrency() {
      if (this.currencyCode === 'no-NO') {
        this.currencySymbol = 'Kr.';
      }
    },
  },

  created() {
    this.initializeCurrency();
    this.initializeWidgets();
  },

};



// WEBPACK FOOTER //
// ./src/app/components/widgets/revenue/revenue.js